import { PageAccessEntryRecord } from "models/view-models/page-access-entry-record";
import PageShareResultRecord from "models/view-models/page-share-result-record";
import QueryHookFactory from "utilities/hooks/queries/query-hook-factory";
import ServiceHookFactory from "utilities/services/service-hook-factory";

export interface PageAccessBasePathParams {
    pageId: number;
}

export interface CreatePageAccessPostParams {
    emails: string[];
    magicLink: string;
}

const baseEndpoint: string = "pages/:pageId/access";

export const PageAccessService = {
    useCreate: ServiceHookFactory.useNestedCreateFromPostParams<
        PageShareResultRecord,
        CreatePageAccessPostParams,
        PageAccessBasePathParams
    >(PageShareResultRecord, baseEndpoint),

    useListQuery: QueryHookFactory.useNestedListQuery<
        PageAccessEntryRecord,
        PageAccessBasePathParams,
        {}
    >("page-access", PageAccessEntryRecord, baseEndpoint),
};

export default PageAccessService;
